import { createColor, editColor } from '../../_services/color.service';
import { getCompany } from '../../_utils/storage_handler';
import { 
    buildCreateColorBody,
    cleanInputs,
    validateCreateColor
} from './create_color.input';

export const createColorEvent = async () => {
    let body = buildCreateColorBody(getCompany());
    validateCreateColor(body);
    let res = await createColor(body);
    if(res.ok){
        cleanInputs();
    } else {
        throw new Error(res.error);
    }
    
    return res;
}

export const editColorEvent = async (id) => {
    let body = buildCreateColorBody(getCompany());
    validateCreateColor(body);
    let res = await editColor(body, id);
    if(! res.ok){
        throw new Error(res.error);
    }
    
    return res;
}